export default "__VITE_ASSET__SC6Z5IYu__"